import { Button as SunriseButton, ThemeProvider } from '@change/ds-core-ui';
import type { ButtonProps } from '@change/ds-core-ui';

export const Button = ({ children, ...props }: ButtonProps) => {
	return (
		<ThemeProvider data-qa="sunrise-provider">
			<SunriseButton {...props}>{children}</SunriseButton>
		</ThemeProvider>
	);
};
